// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_DOPPLERS = [{
  id: 'dopplers_rogue',
  factionId: FACTIONS.DOPPLERS,
  name: 'Принц Подворотни',
  priceNumens: 8000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.PURPLE
  ]
}, {
  id: 'dopplers_intrigue',
  factionId: FACTIONS.DOPPLERS,
  name: 'Серый кардинал',
  priceNumens: 24000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
  ]
}, {
  id: 'dopplers_techno',
  factionId: FACTIONS.DOPPLERS,
  name: 'Инженер отражений',
  priceNumens: 88000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.PINK,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.BLUE
  ]
}, {
  id: 'dopplers_gold_legacy',
  factionId: FACTIONS.DOPPLERS,
  name: 'Самозванец',
  priceNumens: 70000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'dopplers_ruby_legacy',
  factionId: FACTIONS.DOPPLERS,
  name: 'Тысячеликий',
  priceCrystals: 350,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
